<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-demo__appsysenum}">
        <el-form :inline="true" :model="dataForm"   @keyup.enter.native="getDataList()">
          <el-form-item>
            <el-input v-model="dataForm.fullName" placeholder="视频名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataForm.md5" placeholder="md5" clearable></el-input>
          </el-form-item>
          <el-form-item>
          <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="getTimes">
          </el-date-picker>
        </el-form-item>
          <el-form-item>
            <el-button @click="getDataList()">{{ $t('query') }}</el-button>
          </el-form-item>
  <!--        <el-form-item>-->
  <!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
  <!--        </el-form-item>-->
          <el-form-item>
            <el-button v-if="$hasPermission('sys:videouploadinfo:sync')" type="primary" @click="syncVideo()">同步到媒体平台</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:videouploadinfo:save')" type="primary" @click="addOrUpdateHandle()">本地上传视频</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="$hasPermission('sys:videouploadinfo:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
          <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
          
          <el-table-column prop="fullName" label="视频名称" header-align="center" align="center">
  
          </el-table-column>
          <el-table-column  prop="projectName" label="项目" header-align="center" align="center">
            
          </el-table-column>

          <el-table-column prop="detailName" label="明细" header-align="center" align="center"></el-table-column>
             
          <el-table-column prop="typeName" label="视频种类" header-align="center" align="center">
          </el-table-column>
         <el-table-column prop="videoUrl" label="预览" header-align="center" align="center">
           <template slot-scope="scope">
               <!-- <video :src="scope.row.videoUrl" @mouseenter="enter" @mouseleave="out" controls ></video> -->
               <video-play :src="scope.row.videoUrl"></video-play>
            </template>
         </el-table-column>
         <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
         <el-table-column prop="createDate" label="上传时间" header-align="center" align="center"></el-table-column>
         <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center"></el-table-column>
       
         
        
         <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('sys:videouploadinfo:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('updeo') }}</el-button>
              <!-- <el-button v-if="$hasPermission('sys:companies:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
            </template>
          </el-table-column>
          <el-table-column prop="" label="md5" header-align="center" align="center">
          </el-table-column>

         
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <add-or-update-sync v-if="addOrUpdateSyncVisible" :videos="dataListSelections" ref="addOrSyncUpdate" @refreshDataList="getDataList"></add-or-update-sync>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './videoupload-add-or-update'
  import AddOrUpdateSync from './videosync-add-or-update.vue'
  import videoPlay from '@/components/video-play.vue'
  export default {
    mixins: [mixinViewModule],
   
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/sys/videouploadinfo/page',
          getDataListIsPage: true,
          exportURL: '/sys/videouploadinfo/export',
          deleteURL: '/sys/videouploadinfo',
          deleteIsBatch: true
        },
        date:'',
        dataForm: {
          fullName:'',
          createStart:'',
          createEnd:'',
          md5:'',
        }
      }
    },
    mounted(){
    
     
    },
    methods:{
       open(text) {
          this.$alert(text, '内容',{
            lockScroll:false,
            confirmButtonText: '确定',
            // callback: action => {
            //   // this.$message({
            //   //   type: 'info',
            //   //   message: `action: ${ action }`
            //   // });
            // }
          });
         
        },
      syncVideo(){
       
        if(!this.dataListSelections.length){
          this.$message.warning('请选择要同步的视屏')
          return
        }
        this.dataListSelections.length > 10 ? this.$message.warning('视屏同步不能大于十条') : this.addOrUpdateSyncHandle()
      },
      enter(e){
       
        e.target.play()
      },
      out(e){
       
        e.target.pause()
      },
      getTimes() {
          if (this.date != null) {
            this.dataForm.createStart = this.date[0]
            this.dataForm.createEnd = this.date[1]
          }else{
            this.dataForm.createStart =''
            this.dataForm.createEnd = ''
          }
        }
    },
    components: {
      AddOrUpdate,
      AddOrUpdateSync,
      videoPlay
    }
  }
  </script>
  
  <style>
  .value-box{
    position: relative;
  }
    .value{
      overflow:hidden;
      text-overflow:ellipsis; 
      white-space:nowrap 
    }
   
    .hoverValue{
      position: absolute;
      width: 200px;
      height: 300px;
      top: 0;
      left: 10px;
      background: white;
      border: 1px solid black;
      overflow: auto;
      display: none;
      z-index: 999;
    }
  </style>
  
  